var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTakeAwayFlat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m449.023 200.212v302.974c0 4.868-3.926 8.814-8.768 8.814h-368.51c-4.842 0-8.768-3.946-8.768-8.814v-302.974c0-14.16 1.249-28.292 3.733-42.23l15.576-87.414h347.429l15.576 87.414c2.483 13.938 3.732 28.07 3.732 42.23z",
    fill: "#e49a6b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m445.291 157.981-15.576-87.414h-30.905l15.576 87.414c2.484 13.938 3.733 28.07 3.733 42.23v302.974c0 4.868-3.926 8.814-8.768 8.814h30.905c4.842 0 8.768-3.946 8.768-8.814v-302.973c-.001-14.16-1.25-28.292-3.733-42.231z",
    fill: "#e0925b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m440.326 72.887h-368.652c-5.732 0-10.378-4.647-10.378-10.378v-56.328c0-3.414 2.767-6.181 6.181-6.181h377.046c3.414 0 6.181 2.767 6.181 6.181v56.327c0 5.732-4.646 10.379-10.378 10.379z",
    fill: "#e0925b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m444.523 0h-30.905c3.414 0 6.181 2.767 6.181 6.181v56.327c0 5.732-4.647 10.378-10.378 10.378h30.905c5.732 0 10.378-4.647 10.378-10.378v-56.327c0-3.414-2.767-6.181-6.181-6.181z",
    fill: "#d48145"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m326.162 345.43h-140.324c-2.5 0-4.527-2.027-4.527-4.527v-5.26c0-41.249 33.439-74.688 74.688-74.688 41.249 0 74.688 33.439 74.688 74.688v5.26c.001 2.501-2.025 4.527-4.525 4.527z",
    fill: "#f8f7f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 260.956c-5.299 0-10.466.56-15.453 1.61 33.833 7.119 59.235 37.128 59.235 73.078v5.26c0 2.5-2.027 4.527-4.527 4.527h30.905c2.5 0 4.527-2.027 4.527-4.527v-5.26c.001-41.25-33.438-74.688-74.687-74.688z",
    fill: "#efefef"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m272.602 115.103h-33.204c-3.348 0-6.062-2.714-6.062-6.062v-66.17c0-3.348 2.714-6.062 6.062-6.062h33.204c3.348 0 6.062 2.714 6.062 6.062v66.169c0 3.349-2.714 6.063-6.062 6.063z",
    fill: "#f8f7f7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTakeAwayFlat);
export default __webpack_public_path__ + "static/media/take-away-flat.f1f92b645255961022d883b37bd4cf96.svg";
export { ForwardRef as ReactComponent };